<template>
  <v-bottom-navigation class="bottom_nav_main" grow height="60">
    <v-btn
    v-for="item in mobile_menu_items"
    variant="text"
    :ripple="true"
    @click="item.action?.()"
    :key="item.value"
    class="bottom_nav_btn ma-0 pa-0"
    :id="item.id || undefined"
    :value="item.value"
    color="primary"
    v-bind="item.to ? { to: item.to } : {}">    
    <SvgIcon v-if="item.image" :icon="item.image" class="bottom_nav_icon" />
    <SvgIcon v-else :icon="item.imageFallback" class="bottom_nav_icon" />
    <span class="bottom_nav_title">{{ item.label }}</span>
  </v-btn>
</v-bottom-navigation>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAppStates } from '@/store/appStates';
import { useUserStore } from '@/store/userJWTStore';
import SvgIcon from '@/components/GlobalComponents/SvgIcon.vue';

const appStates = useAppStates();
const store = useUserStore();

const isLoggedIn = computed(() => store.isLoggedIn);

// Define the mobile menu items with their properties
const mobile_menu_items = computed(() => [
  {
    value: 'feed',
    to: '/dashboard?tab=feed',
    image: '',
    imageFallback: 'feed',
    label: 'Feed',
  },
  {
    value: 'add_result',
    to: isLoggedIn.value ? '/add_result' : '/login',
    image: '',
    imageFallback: 'add',
    label: 'Add Result',
  },
  {
    value: 'search',
    to: '/search',
    image: '',
    imageFallback: 'search',
    label: 'Search',
  },
  {
    value: 'rankings',
    to: '/players',
    image: '',
    imageFallback: 'ranking',
    label: 'Rankings',
  },
  {
    value: 'menu',
    to: null,
    image: '',
    imageFallback: 'burger',
    label: 'Menu',
    id: 'bottom_nav_fullNav_btn',
    action: () => appStates.toggleMobilePanel(),
  },
]);
</script>

<style lang="scss">

// Ensure the bottom Nav always fills the width of the screen
.bottom_nav_main {
  z-index: 1007;
  width: 100%;
  display: none;
  z-index: 100001 !important; // Ensure the Bottom Nav is always on top on Side Nav
}

// Add Background color to the Bottom Nav after removing the overlay and underlay double click
.bottom_nav_main .v-btn--active {
  background: $active_button_background_color !important;
}

// Style the bottom Nav Title
.bottom_nav_title {
  font-family: $brandon-grotesque-font;
  color: rgb(var(--v-theme-primary));
  text-transform: uppercase;
  font-size: 8px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: 0.5px;
  text-align: center;
  padding-top: 7px;
}

// Remove the border radius from the Bottom Nav Buttons
.bottom_nav_btn {
  // border-radius: 0px;
  flex: 1 1 0;
  min-width: 60px !important;
  
  .v-btn__overlay {
    display: none !important;
  }
  
  .v-btn__underlay {
    display: none !important;
  }
}

// Custom Styling for the Bottom Nav Full Nav Button
#bottom_nav_fullNav_btn img {
  height: 14px !important;
  top: 4px;
}

// Show the Bottom Nav on mobile screens
@media (max-width: $mobile-screen) {
  .bottom_nav_main {
    display: flex !important;
    padding-bottom: calc(var(--safe-area-inset-bottom, 0px)) !important;
    height: calc(60px + var(--safe-area-inset-bottom, 0px)) !important;
    transition: height 0.3s ease-in-out, padding-bottom 0.3s ease-in-out;
  }
}

.bottom_nav_icon {
  width: 21px;
  height: 21px;
  color: rgb(var(--v-theme-primary));
}
</style>
